module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('groupPages.modules.events.title')))]), _c('ul', {
    staticClass: "events"
  }, _vm._l((_vm.module.items), function(event) {
    return _c('li', [_c('strong', {
      staticClass: "title"
    }, [_vm._v(_vm._s(event.name))]), _vm._v(" \n "), _c('span', {
      staticClass: "address"
    }, [_vm._v(_vm._s(event.city)), (event.city) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" " + _vm._s(event.country))]), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("fromTo")([event.startTime * 1000, event.endTime * 1000])))]), (_vm.openEditor) ? _c('div', [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          return _vm.unpublish(event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('globals.unpublish')) + "  ")])]) : _vm._e()])
  }), 0), (_vm.openEditor) ? [_c('div', {
    staticClass: "btn btn-primary pright",
    on: {
      "click": _vm.showEvents
    }
  }, [_vm._v(_vm._s(_vm.$t('groupPages.modules.events.publishMore')))]), _c('div', {
    staticClass: "cf"
  }), _c('div', {
    ref: "modal",
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('groupPages.modules.events.title')))])]), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.eventsListStatus == _vm.STATUS.LOADING) ? [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })] : _c('ul', {
    staticClass: "events"
  }, [_vm._l((_vm.eventsList), function(event) {
    return _c('li', [_c('strong', {
      staticClass: "title"
    }, [_vm._v(_vm._s(event.name))]), _vm._v(" \n "), _c('span', {
      staticClass: "address"
    }, [_vm._v(_vm._s(event.city)), (event.city) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" " + _vm._s(event.country))]), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("fromTo")([event.startTime * 1000, event.endTime * 1000])))]), (_vm.openEditor) ? _c('div', [(!event.public) ? _c('button', {
      staticClass: "btn btn-xs btn-success",
      on: {
        "click": function($event) {
          return _vm.publish(event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('globals.publish')) + "   ")]) : _c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          return _vm.unpublish(event)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('globals.unpublish')))])]) : _vm._e()])
  }), (_vm.eventsList.length == 0) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('groupPages.modules.events.nothing')) + " ")])]) : _vm._e()], 2), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": _vm.createEvent
    }
  }, [_vm._v(_vm._s(_vm.$t('groupPages.modules.events.createEvent')))])])], 2)])])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28b7f27a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupPages/GroupPageEvents.vue
// module id = 1255
// module chunks = 2